import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {fetchAndParse, FetchResult} from './Common';
interface DocumentNodeOptions {
	context: NodeContext;
	type: string;
}

export const NODE_CONTEXT_LABEL: Record<NodeContext, string> = {
	[NodeContext.ANIM]: 'Animation',
	[NodeContext.AUDIO]: 'Sound',
	[NodeContext.COP]: 'Textures',
	[NodeContext.EVENT]: 'Scene Events',
	[NodeContext.SOP]: 'Procedural Modeling',
	[NodeContext.GL]: 'Advanced Shaders',
	[NodeContext.JS]: 'States & Events + Advanced Operations',
	[NodeContext.MAT]: 'Materials',
	[NodeContext.OBJ]: 'Objects',
	[NodeContext.POST]: 'Post Processing',
	[NodeContext.ROP]: 'Renderers',

	[NodeContext.MANAGER]: '',
};
export const NON_DOCUMENTED_CONTEXTS: Set<NodeContext> = new Set([NodeContext.MANAGER]);

export class DocumentNodeClass {
	private static _instance: DocumentNodeClass;
	static instance() {
		return (this._instance = this._instance || new DocumentNodeClass());
	}
	private constructor() {}

	private _resultByUrl: Map<string, FetchResult> = new Map();
	url(options: DocumentNodeOptions) {
		return `/editor/docs/description/nodes/${options.context}/${options.type.toLowerCase()}.md`;
	}

	async fetch(options: DocumentNodeOptions): Promise<FetchResult | undefined> {
		const url = this.url(options);
		let result = this._resultByUrl.get(url);
		if (!result) {
			result = await fetchAndParse(url);
		}
		return result;
	}
}

export const DocumentNode = DocumentNodeClass.instance();
